import styled, { css } from 'styled-components';
import ripple from '../../assets/svg/ripple.svg';

export const SCButton = styled.button`
  background-color: ${p => p.theme.color[p.primary ? 'teal' : 'white']};
  box-shadow: ${p => (p.raised ? p.theme.boxShadow2 : 'none')};
  border: 0;
  border-radius: 2px;
  color: ${p => p.theme.color[p.primary ? 'white' : 'black']};
  display: inline-block;
  font-family: ${p => p.theme.base.fontFamily};
  font-size: ${p => (p.big ? '16px' : '12px')};
  font-weight: 700;
  line-height: ${p => (p.big ? '45px' : '30px')};
  padding: ${p => (p.big ? '0 45px' : '0 30px')};
  text-decoration: 0;
  text-transform: uppercase;
  transition: all 0.2s linear;
  white-space: no-wrap;

  ${p =>
    p.disabled &&
    css`
      background-color: ${p.theme.color.gray};
      color: black;
      cursor: not-allowed;
      opacity: 0.9;
    `};
  ${p =>
    p.attention &&
    css`
      animation: ${p.theme.pulse} 1s infinite;
    `};

  &:hover,
  &:active {
    background-color: ${p =>
      p.theme.color[p.primary ? p.theme.rgba('teal', 0.6) : 'grayLight']};
    box-shadow: none;
    opacity: 0.8;
  }
`;

export const SCSubmitButton = styled.button`
  background-color: ${p => p.theme.color.teal};
  box-shadow: ${p => (p.raised ? p.theme.boxShadow2 : 'none')};
  border: 0;
  border-radius: 2px;
  color: ${p => p.theme.color.white};
  display: inline-block;
  font-family: ${p => p.theme.base.fontFamily};
  font-size: 16px;
  font-weight: 600;
  height: 45px;
  line-height: 40px;
  min-width: 120px;
  padding: 0 35px;
  position: relative;
  text-decoration: 0;
  text-transform: uppercase;
  transition: all 0.2s linear;
  white-space: no-wrap;

  &::after {
    content: '';
    position: absolute;
    top: 0px;
    left: 0;
    right: 0;
    bottom: 0;
    background: url(${ripple}), ${p => p.theme.color.teal};
    background-size: 45px;
    background-repeat: no-repeat;
    background-position: top;
    transition: all 0.2s ease;
    transform: scale(0);
  }

  ${p =>
    p.state === 'disabled' &&
    css`
      background-color: ${p.theme.color.gray};
      color: black;
      cursor: not-allowed;
      opacity: 0.9;
    `};

  ${p =>
    p.state === 'loading' &&
    css`
      &::after {
        transform: scale(1);
      }
    `};

  ${p =>
    p.state === 'attention' &&
    css`
      animation: ${p.theme.pulse} 1s infinite;
    `};

  &:hover,
  &:focus {
    background-color: ${p => p.theme.color.teal};
    opacity: 0.8;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Buttons/styles.js